{
  "title": "Title",
  "shot": "Shot",
  "date": "Date",
  "talent": "Talent",
  "rush_file": "Rush file",
  "rush_file_cover": "Rush file cover",
  "rush_submit": "submit rush"
}
